import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import BasketPopupContainer from './BasketPopupContainer';
import { ComparePopupContainer } from './ComparePopupContainer';
const EssentialsContainer = ({ basketPopUp }) => (_jsxs(_Fragment, { children: [_jsx(BasketPopupContainer, { recommendations: basketPopUp }), _jsx(ComparePopupContainer, {})] }));
export default EssentialsContainer;
